// extracted by mini-css-extract-plugin
export var button = "_ly-2";
export var card = "_ly-0";
export var closeButtonContainer = "_ly-3";
export var iconContainer = "_ly-1";